import {
  DialogPositioningBehavior,
  DialogProps,
  DialogType,
  DialogWidget
} from '@tableau/widgets';
import React from 'react';

  import { Messages } from '~src/codegen/Localize';
import { CloseAndDismiss, ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

import { KMSKeyRestoreForbiddenView } from '../components/KMSKeyRestoreForbiddenView';


export const openKMSKeyRestoreForbiddenDialog = (): void => {
      ReactModalService.openCustom(closeAndDismiss => {
          const dialogProps = ReactModalService.getDefaultDialogProps({
              type: DialogType.NormalWithTitleBar,
              title: Messages.credentialEncryption_KMSKeyRestoreDialog_Title(),
              testId: 'data-key-restore-forbidden-dialog',
              showCloseButton: true,
              dialogWidth: TabDialogWidth.width500px,
              positioningBehavior: DialogPositioningBehavior.Draggable,
              shouldNotCloseOnGlassClick: true
          }, closeAndDismiss);
          return getDialogWidget(dialogProps, closeAndDismiss);
      });

  };


  function getDialogWidget(dialogProps: DialogProps, closeAndDismiss: CloseAndDismiss) {
    return (
      <DialogWidget {...dialogProps}>
        {<KMSKeyRestoreForbiddenView closeDialog={closeAndDismiss} />}
      </DialogWidget>
    );
  }